let single = null
const menu = {
  admin: [{ title: 'Сотрудники', icon: 'business_center', url: '/registrars' }],
  admin_sign: [{ title: 'Сотрудники', icon: 'business_center', url: '/registrars' }],
  registrar: [{ title: 'Абоненты', icon: 'people', url: '/subscribers' }],
  registrar_sign: [{ title: 'Проверка', icon: 'check_circle', url: '/check' }],
  super_admin: [
    { title: 'Абоненты', icon: 'people', url: '/subscribers' },
    { title: 'Сотрудники', icon: 'business_center', url: '/registrars' },
    { title: 'Проверка', icon: 'check_circle', url: '/check' }
  ]
}
const path = {
  admin: { path: '/registrars' },
  admin_sign: { path: '/registrars' },
  registrar: { path: '/subscribers' },
  registrar_sign: { path: '/check' },
  super_admin: { path: '/subscribers' }
}

const registration = {
  admin: { isAdmin: false, isSign: false, key: 'RegisterRegistrar', type: { registrars: 'GET_OPERATORS_LIST' } },
  admin_sign: { isAdmin: false, isSign: true, key: 'RegisterRegistrar', type: { registrars: 'GET_OPERATORS_LIST' } },
  registrar: { isAdmin: false, isSign: false, key: 'RegisterUser', type: { subscribers: 'GET_SUBSCRIBERS_LIST' } },
  super_admin: {
    entity: {
      isAdmin: false,
      isSign: false,
      key: 'RegisterRegistrar',
      type: { subscribers: 'GET_SUBSCRIBERS_LIST', registrars: 'GET_OPERATORS_LIST' }
    },
    individual: {
      isAdmin: false,
      isSign: false,
      key: 'RegisterUser',
      type: { subscribers: 'GET_SUBSCRIBERS_LIST', registrars: 'GET_OPERATORS_LIST' }
    }
  }
}

const allRoles = ['super_admin', 'admin', 'admin_sign', 'registrar', 'registrar_sign']

function Roles(name) {
  let currentRole = name

  this.getMenu = () => {
    return menu[currentRole]
  }

  this.getPath = () => {
    return path[currentRole]
  }

  this.setRole = name => {
    if (!allRoles.includes(name)) return { error: `${name} - такой роли не существует.` }
    currentRole = name
    return {}
  }

  this.getRegistrationData = userType => {
    const r = currentRole === 'super_admin' ? registration[currentRole][userType] : registration[currentRole]
    return { ...r }
  }
}

function getConfig(name) {
  if (!single) {
    single = new Roles(name)
  }
  return single
}

export default getConfig
